import React, { Component } from "react";
import { Link, } from 'react-router-dom'
import { connect } from 'react-redux'
import { AssessDashCircleSVG } from "./AssessDashCircleSVG";


//  A circle with a number in it used for displaying 
//  scores on various reports.
class AssessDashCircle extends Component {

  clicked = (skillReportLink) => {
    <Link className='m2link-black link' to={skillReportLink} style={{ 'textDecoration': 'none' }}></Link>
  }

  render() {


    let role = (this.props.state.testUser.role === 'Student')
    let studentSelected = this.props.st.users.student_selected_value

    let { subject,
      score,
      onPage,
      top,
      isAssessmentInitializing,
      subtestAssessCircle,
      skillReportLink,
      compareScore,
      sub,
      isCompare,
      title,
      test1,
      test2,
      isSwap } = this.props

    if (subtestAssessCircle && isAssessmentInitializing) {

    }
    const subjectLC = subject.toLowerCase()

    // The circle classes are pulled by integer, so have
    // to calculate that include in className.
    let scoreInt = Math.round(score);
    if (Number.isNaN(compareScore) || (compareScore === undefined)) {
      compareScore = 0
    }
    let ComparisonScore = Math.round(compareScore * 10) / 10;
    ComparisonScore = ComparisonScore.toFixed(1);
    // let ComparisonScore = Math.round(compareScore)

    // If score is less than 36 but rounds up to 36, still show
    // the circle as not being completely filled in.
    if (score > 35 && score < 36) {
      scoreInt = 35
    }

    if (Number.isNaN(scoreInt)) {
      scoreInt = 0
    }
    //---------
    if (compareScore > 35 && compareScore < 36) {
      ComparisonScore = 35
    }


    let nameLI = <li className='section-name' onClick={() => { this.clicked(skillReportLink) }}>{subject}</li>
    // if (top) {
    //   nameLI = <li className='section-name' onClick={()=>{this.clicked(skillReportLink)}}>{subject}</li>
    // }

    let scoreNum = score ? (role ? Number(score).toFixed(0) : (!studentSelected || this.props.st.users.student_selected_value.value === '---') ? Number(score).toFixed(1) : Number(score).toFixed(0)) : 0;
    let scoreValue = scoreNum.toString().split('.');

    ComparisonScore = ComparisonScore ? (role ? Number(ComparisonScore).toFixed(0) : (!studentSelected || this.props.st.users.student_selected_value.value === '---') ? Number(ComparisonScore).toFixed(1) : Number(ComparisonScore).toFixed(0)) : 0;

    return (
      <div className="donut-chart-container">
        <div className={`donut-chart ${subjectLC} ${subjectLC}-${scoreInt}`}  >
          <AssessDashCircleSVG num={0} strokeColorOuter={`${subjectLC}-outer`} strokeColorInner={`${subjectLC}-inner`} currentScore={scoreInt} comparisonScore={ComparisonScore} barRadius={'50'} barOuterRadius={'57'} isCompare={isCompare} test1={test1} test2={test2} isSwap={isSwap} />
          <ul className='assessment-score' >
            {sub
              ?
              <Link className='m2link-black link' to={skillReportLink} style={{ 'textDecoration': 'none' }}>
                <li className='section-score'  >
                  {scoreValue[1] ? <React.Fragment><span className="section-score-text">{scoreValue[0]}</span><span className="section-score-sub">.{scoreValue[1]}</span></React.Fragment> : <span className="section-score-text">{scoreNum}</span>}
                </li>
              </Link>
              :
              <h2 className='title'> <li className='section-score'  >
                {scoreValue[1] ? <React.Fragment><span className="section-score-text">{scoreValue[0]}</span><span className="section-score-sub">.{scoreValue[1]}</span></React.Fragment> : <span className="section-score-text">{scoreNum}</span>}
              </li>
              </h2>
            }
            {nameLI}
          </ul>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    state: state.users,
    st: state,
    testUser: state.users.checkuser,
    authed: state.users.authed
  }
}


export default connect(mapStateToProps, null)(AssessDashCircle)




// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDashCircle.js